import React, { useState } from "react";
import { Link } from "react-router-dom";
import { SiteHeader, SiteFooter, Notice } from "../components/Layout";
import { api } from "../lib/api";
import { prettyDate, timeRange, cleanPhone } from "../lib/slots";

const slotsOf = (b) => (Array.isArray(b.slots) ? b.slots : String(b.slots || "").split(",").map((s) => s.trim()).filter(Boolean));

export default function Manage() {
  const [phone, setPhone] = useState("");
  const [userBookings, setUserBookings] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [searched, setSearched] = useState(false);

  const searchBookings = async (e) => {
    e.preventDefault();
    if (phone.trim().length !== 10) {
      setMessage("⚠️ Please enter a valid 10-digit phone number");
      return;
    }
    try {
      setLoading(true);
      setMessage("");
      const result = await api("my-bookings", { method: "POST", body: { phone: phone.trim() } });
      const data = result.bookings || [];
      setSearched(true);
      if (data.length > 0) {
        setUserBookings(data);
        setMessage("");
      } else {
        setUserBookings([]);
        setMessage("⚠️ No upcoming bookings found for this phone number.");
      }
    } catch (error) {
      console.error("Error fetching bookings:", error);
      setMessage("❌ Error fetching bookings. Please try again.");
      setUserBookings([]);
    } finally {
      setLoading(false);
    }
  };

  const cancelBooking = async (bookingId) => {
    if (!window.confirm("Are you sure you want to cancel this booking?")) return;
    try {
      // The server checks the booking actually belongs to this phone number,
      // so an id on its own is not enough to cancel someone else's slot.
      await api("my-bookings", { method: "POST", body: { phone: phone.trim(), cancelId: bookingId } });
      setMessage("✅ Booking cancelled successfully!");
      setUserBookings(userBookings.filter((b) => b.id !== bookingId));
    } catch (error) {
      console.error("Error cancelling booking:", error);
      setMessage(`❌ ${error.message || "Failed to cancel booking. Please try again."}`);
    }
  };

  return (
    <div className="vv-page vv-page--paper">
      <SiteHeader />
      <main className="vv-wrap vv-wrap--narrow vv-manage">
        <div className="vv-book__head">
          <h1 className="vv-display vv-h1">Manage your bookings</h1>
          <p className="vv-book__sub">Enter the WhatsApp number you booked with to see and cancel your upcoming bookings.</p>
        </div>

        <form onSubmit={searchBookings} className="vv-panel vv-manage__search">
          <label className="vv-field">
            <span className="vv-field__label">WhatsApp number</span>
            <span className="vv-phone">
              <span className="vv-phone__cc">+91</span>
              <input
                type="tel"
                inputMode="numeric"
                className="vv-input vv-phone__input"
                placeholder="9876543210"
                value={phone}
                onChange={(e) => setPhone(cleanPhone(e.target.value))}
                required
              />
            </span>
          </label>
          <button type="submit" disabled={loading || phone.length !== 10} className="vv-btn vv-btn--strong">
            {loading ? "Searching…" : "Find my bookings"}
          </button>
        </form>

        <Notice message={message} />

        {userBookings.length > 0 && (
          <section aria-labelledby="list-h" className="vv-stack">
            <h2 id="list-h" className="vv-panel__title">Upcoming bookings ({userBookings.length})</h2>
            {userBookings.map((booking) => {
              const slots = slotsOf(booking);
              return (
                <div key={booking.id} className="vv-panel vv-bookingcard">
                  <div className="vv-bookingcard__main">
                    <div className="vv-display vv-bookingcard__date">
                      {prettyDate(String(booking.booking_date).slice(0, 10), { weekday: "short", day: "numeric", month: "short" })}
                    </div>
                    <div className="vv-bookingcard__time">{timeRange(slots) || slots.join(", ")}</div>
                    <dl className="vv-bookingcard__meta">
                      <div><dt>Slots</dt><dd>{slots.length} × 30 min</dd></div>
                      <div><dt>Total</dt><dd>₹{booking.total_price}</dd></div>
                    </dl>
                  </div>
                  <button type="button" onClick={() => cancelBooking(booking.id)} className="vv-btn vv-btn--danger">
                    Cancel booking
                  </button>
                </div>
              );
            })}
          </section>
        )}

        {searched && userBookings.length === 0 && (
          <p className="vv-muted">Want to play? <Link to="/book">Book a court</Link>.</p>
        )}
      </main>
      <SiteFooter />
    </div>
  );
}
